import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceAssessment from './pages/ServiceAssessment';
import ServiceImplementation from './pages/ServiceImplementation';
import ServiceAdvisor from './pages/ServiceAdvisor';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import AgenticAI from './pages/AgenticAI';
import './styles.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <div className="app">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/ai-readiness-assessment" element={<ServiceAssessment />} />
            <Route path="/services/ai-strategy-implementation" element={<ServiceImplementation />} />
            <Route path="/services/ai-advisor" element={<ServiceAdvisor />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/agentic-ai" element={<AgenticAI />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    </HelmetProvider>
  );
}
